// Module
var code = "<h3>Edit Organisation</h3> <div class=\"card mb-2\"> <div id=\"org-form\" class=\"grid pt-4\"></div> </div> <div class=\"mb-8 flex justify-end items-center\"> <button id=\"\" onclick=\"thsPage.updateOrg()\" class=\"mt-8\">Update Organisation</button> </div> ";
// Exports
export default code;